import React, { useState, useEffect } from "react";
import { useTranslation } from 'react-i18next';

const OfflineChaptersPage = () => {
  const [offlineChapters, setOfflineChapters] = useState([]);
  const { t } = useTranslation();

  useEffect(() => {
    // Lấy danh sách các chương đã lưu trong localStorage
    const chapters = [];
    Object.keys(localStorage).forEach((key) => {
      if (key.startsWith("chapter-")) {
        const chapter = JSON.parse(localStorage.getItem(key));
        chapters.push({ id: key.split("-")[1], title: chapter.title });
      }
    });
    setOfflineChapters(chapters);
  }, []);

  return (
    <div>
      <h1>{t('offlineChapters')}</h1>
      {offlineChapters.length === 0 ? (
        <p>{t('noChaptersSaved')}</p>
      ) : (
        <ul>
          {offlineChapters.map((chapter) => (
            <li key={chapter.id}>
              <a href={`/chapters/${chapter.id}/offline`}>{chapter.title}</a>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default OfflineChaptersPage;